import { store } from '../store/store.js';
import { debounce } from '../base/helpers.js';
import Swiper from 'swiper';

/**
 * InitAlert
 */
export default class InitCarousel{

	constructor(){

		/**
		 * Initalise Class Cache
		 * @type {obj}
		 */
		this.cache = {
			$carousel:       $('.carousel'),
            carouselClass:   '.swiper'
		};

		if(this.cache.$carousel.length){
			this.renderCarousel();
		}
	}


	/**
	 * @property {Function} renderCarousel -
	 * @returns void
	 */
    renderCarousel(){
        this.cache.$carousel.each(function(index, self){
            const $_self = $(self);
            const slidesPerView = $_self.data('slides-per-view')
                ? $_self.data('slides-per-view')
                : {small: 1, medium: 1, large: 1, maximum: 1};
            const effect = $_self.data('effect')
                ? $_self.data('effect')
                : "slide";
            const slidesOffset = $_self.data('slides-offset')
                ? $_self.data('slides-offset')
                : {small: 0, medium: 0, large: 0, maximum: 0};
            const spaceBetween = $_self.data('space-between')
                ? $_self.data('space-between')
                : {small: 30, medium: 30, large: 30, maximum: 30};

            new Swiper($_self.find(this.cache.carouselClass), {
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                slidesPerView: Number(slidesPerView.maximum),
                spaceBetween: Number(spaceBetween.maximum),
                slidesOffsetBefore: Number(slidesOffset.maximum),
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                effect: effect,
                breakpoints: {
                    [`${store.breakPoints.small}`]: {
                      slidesPerView: Number(slidesPerView.small),
                      spaceBetween: Number(spaceBetween.small),
                      slidesOffsetBefore: Number(slidesOffset.small)
                    },
                    [`${store.breakPoints.medium}`]: {
                      slidesPerView: Number(slidesPerView.medium),
                      spaceBetween: Number(spaceBetween.medium),
                      slidesOffsetBefore: Number(slidesOffset.medium)
                    },
                    [`${store.breakPoints.large}`]: {
                      slidesPerView: Number(slidesPerView.large),
                      spaceBetween: Number(spaceBetween.large),
                      slidesOffsetBefore: Number(slidesOffset.large)
                    },
                    [`${store.breakPoints.maximum}`]: {
                      slidesPerView: Number(slidesPerView.maximum),
                      spaceBetween: Number(spaceBetween.maximum),
                      slidesOffsetBefore: Number(slidesOffset.maximum)
                    }
                },
            });
        }.bind(this));
    }
}
